import React from 'react';

const PortfolioPage = (props) => {
  const { setOpen, address, balance, usdBalance, claimedDividend, pendingDividend, claimedReflection, pendingReflection, claimDividend, claimReflection, claimBoth } = props;
  const cardStyle = "p-3 h-30 md:h-60 w-full min-h-24 flex flex-col justify-between flex-grow shadow bg-gray-800 rounded-lg text-xl text-slate-300"
  const gridStyle = "grid content-start gap-2 xl:grid-cols-2 text-center lg:grid-cols-2 md:grid-cols-1 text-slate-300"

  if (address) {
  return (
    // <div class="grid content-start gap-2 text-center text-white xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-1">
    <div class={gridStyle}>
      <div class={cardStyle}>
        <p class="text-xl">Portfolio Overview</p>
        <table class="table-auto text-left text-md">
          <thead class="border-b-2 border-gray-400">
            <tr className="text-gray-400">
              <th>METRIC</th>
              <th>VALUE</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Balance ($INC)</td>
              <td>{balance}</td>
            </tr>
            <tr>
              <td>Pending Dividends (ETH)</td>
              <td>{pendingDividend}</td>
            </tr>
            <tr>
              <td>Claimed Dividends (ETH)</td>
              <td>{claimedDividend}</td>
            </tr>
            <tr>
              <td>Pending Reflections ($INC)</td>
              <td>{pendingReflection}</td>
            </tr>
            <tr>
              <td>Claimed Reflections ($INC)</td>
              <td>{claimedReflection}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class={cardStyle + ' space-y-4'}>
        <p class="text-xl">Pending Dividends</p>
        <p className="text-4xl">{pendingDividend} ETH</p>
        <button onClick={() => claimDividend()} className="align-self-center transition ease-in-out hover:scale-110 duration-300 whitespace-nowrap inline-flex justify-center px-4 py-2 border-0 rounded-md shadow-sm text-base font-medium text-white bg-blue-600 hover:bg-blue-700">
          Claim ETH
        </button>
      </div>
      <div class={cardStyle + ' space-y-4'}>
        <p class="text-xl">Pending Reflections</p>
        <p className="text-4xl">{pendingReflection} $INC</p>
        <button onClick={() => claimReflection()}className="align-self-center transition ease-in-out hover:scale-110 duration-300 whitespace-nowrap inline-flex justify-center px-4 py-2 border-0 rounded-md shadow-sm text-base font-medium text-white bg-blue-600 hover:bg-blue-700">
          Claim $INC
        </button>
      </div>
      <div class={cardStyle + ' space-y-4'}>
        <div></div>
        <button onClick={() => claimBoth()}className="align-self-center transition ease-in-out hover:scale-110 duration-300 whitespace-nowrap inline-flex justify-center px-4 py-2 border-0 rounded-md shadow-sm text-base font-medium text-white bg-blue-600 hover:bg-blue-700">
          Claim Dividend and Reflection
        </button>
        <div></div>
      </div>
    </div>
    );
  } else {
    return(<div class="grid content-start gap-2 text-center text-white xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-1">
    <div class='p-3 h-30 md:h-60 w-full min-h-24 flex flex-col flex-grow shadow bg-gray-800 rounded-lg text-xl text-slate-300 justify-center'>
      <p class="text-2xl mb-4">Connect your wallet to access your portfolio</p>
      <button onClick={() => setOpen(true)} className="align-self-center transition ease-in-out hover:scale-110 duration-300 whitespace-nowrap inline-flex justify-center px-4 py-2 border-0 rounded-md shadow-sm text-base font-medium text-white bg-blue-600 hover:bg-blue-700">
        Connect
      </button>
    </div>
  </div>);
  }

}

export default PortfolioPage;